import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Typography, Accordion, AccordionSummary, AccordionDetails, AccordionActions } from "@material-ui/core";
import SimpleInput from "../../components/Frequents/SimpleInput";
import SimpleInputComment from "../../components/Frequents/SimpleInputComment";
import SimpleReadOnly from "../../components/Frequents/SimpleReadOnly";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PremiumBadge from "../../components/Frequents/PremiumBadge";
import ReactToPrint from "react-to-print";
import NewCustomFieldJournal from "./NewCustomFieldJournal.js";
import moment from "moment";
import API from "../../actions";
import update from "immutability-helper";
import { UploadFile } from "../UploadImage/UploadImage.jsx";

export default props => {
    const printRef = useRef();
    const therapist = useSelector(state => state.data.therapist);

    const [journal, setJournalComponent] = useState(props.journal);
    const [customFields, setCustomFields] = useState([]);
    const [journalUpdate, setJournalUpdate] = useState('');

    const changeValueJournal = type => async value => {
        const newJournal = update(journal, {
            [type]: { $set: value },
            updatedBy: { $set: therapist.nameFirst + " " + therapist.nameLast }
        });
        setJournalComponent(newJournal);
        await API.setJournal(newJournal);
    };

    const changeValueCustomField = index => async value => {
        const newFields = update(customFields, {
            [index]: {
                value: {
                    $set: value
                }
            }
        });
        const newJournal = update(journal, {
            updatedBy: { $set: therapist.nameFirst + " " + therapist.nameLast }
        });

        setCustomFields(newFields);
        setJournalComponent(newJournal);
        await API.setCustomFieldsJournal(journal.id, [newFields[index]]);
        await API.setJournal(newJournal);
    };

    const getFieldComments = (fieldName) => {
        return journal.comments.filter(cm => cm.customFieldName === fieldName);
    }

    useEffect(() => {
        (async () => {
            setCustomFields(await API.getCustomFieldsFromJournal(props.journal.id));
            updateJournalUpdate();
        })();
    }, [props.journal.id]);

    if (!journal || !therapist) return <></>;

    // console.log('journal', journal);

    const updateJournalUpdate = () => {
        let updatedAts = [journal.updatedAt]
        for (const comment of journal.comments) {
            updatedAts.push(comment.updatedAt);
        }
        setJournalUpdate(Math.max(...updatedAts));
    }

    const getCanEditDataStatus = (obj, field) => {
        if (!obj[field]) {
            return true;
        }

        const endTime = new Date(obj[field]).getTime();
        return new Date().getTime() < +endTime + 86400000;
    };

    return (
        <Accordion key={"jouanlExpansion" + journal.id} expanded={props.expanded === journal.id} ref={printRef}>
            <AccordionSummary
                onClick={props.expand}
                expandIcon={<ExpandMoreIcon />}
                aria-controls={journal.id}
                id={journal.id}>
                <div>
                    <Typography>
                        Journal fra {moment(new Date(Number(journal.from))).format("DD/MM/YYYY, HH:mm:ss")} sidst rettet{" "}
                        {moment(new Date(journalUpdate)).format("DD/MM/YYYY")}
                        {journal.updatedBy ? " - " + journal.updatedBy : ""}
                    </Typography>
                </div>
            </AccordionSummary>

            <AccordionDetails>
                <form
                    name={journal.id}
                    style={{
                        width: "100%"
                    }}>
                    <SimpleReadOnly
                        id={journal.id + "klient"}
                        text="Klient"
                        prop={props.clickedClient.nameFirst + " " + props.clickedClient.nameLast}
                    />
                    <SimpleReadOnly id={journal.id + "behandling"} text="Behandling" prop={journal.treatmentName} />
                    <SimpleReadOnly
                        id={journal.id + "behandler"}
                        text="Behandler"
                        prop={therapist.nameFirst + " " + therapist.nameLast}
                    />
                    <SimpleInputComment
                        canEditData={getCanEditDataStatus(journal, 'firstInputEffectDate')}
                        journalId={journal.id}
                        therapist={therapist}
                        id={journal.id + "effect"}
                        multiline={true}
                        name="clientJournalEffect"
                        text="Hvordan er det gået siden sidst?"
                        prop={journal.effect}
                        changeValue={changeValueJournal("effect")}
                        key={props.clickedClient.id + "journaleffect"}
                        clickedClient={props.clickedClient}
                        enableComment={true}
                        updatedAt={journal.updatedAt}
                        comments={getFieldComments('clientJournalEffect')}
                    />
                    {/* <SimpleInput
                        canEditData={props.canEditData}
                        id={journal.id + "effect"}
                        multiline={true}
                        name="clientJournalEffect"
                        text="Hvordan er det gået siden sidst?"
                        prop={journal.effect}
                        changeValue={changeValueJournal("effect")}
                        key={props.clickedClient.id + "journaleffect"}
                    /> */}
                    <SimpleInputComment
                        canEditData={getCanEditDataStatus(journal, 'firstInputTreatmentUpDate')}
                        journalId={journal.id}
                        therapist={therapist}
                        id={journal.id + "treatment"}
                        multiline={true}
                        name="clientJournalTreatment"
                        text="Aktuel behandling"
                        prop={journal.treatment}
                        changeValue={changeValueJournal("treatment")}
                        key={props.clickedClient.id + "journaltreatment"}
                        clickedClient={props.clickedClient}
                        enableComment={true}
                        updatedAt={journal.updatedAt}
                        comments={getFieldComments('clientJournalTreatment')}
                    />
                    {/* <SimpleInput
                        canEditData={props.canEditData}
                        id={journal.id + "treatment"}
                        multiline={true}
                        name="clientJournalTreatment"
                        text="Aktuel behandling"
                        prop={journal.treatment}
                        changeValue={changeValueJournal("treatment")}
                        key={props.clickedClient.id + "journaltreatment"}
                    /> */}

                    <SimpleInputComment
                        canEditData={getCanEditDataStatus(journal, 'firstInputFollowUpDate')}
                        journalId={journal.id}
                        therapist={therapist}
                        id={journal.id + "followUp"}
                        multiline={true}
                        name="clientJournalFollowUp"
                        text="Opfølgning / aftaler"
                        prop={journal.followUp}
                        changeValue={changeValueJournal("followUp")}
                        key={props.clickedClient.id + "followUp"}
                        clickedClient={props.clickedClient}
                        enableComment={true}
                        updatedAt={journal.updatedAt}
                        comments={getFieldComments('clientJournalFollowUp')}
                    />
                    {/* <SimpleInput
                        canEditData={props.canEditData}
                        id={journal.id + "followUp"}
                        multiline={true}
                        name="clientJournalFollowUp"
                        text="Opfølgning / aftaler"
                        prop={journal.followUp}
                        changeValue={changeValueJournal("followUp")}
                        key={props.clickedClient.id + "followUp"}
                    /> */}


                    <SimpleInputComment
                        canEditData={getCanEditDataStatus(journal, 'firstInputRemarkUpDate')}
                        journalId={journal.id}
                        therapist={therapist}
                        id={journal.id + "remark"}
                        multiline={true}
                        name="clientJournalRemark"
                        text="Egne bemærkninger"
                        prop={journal.remark}
                        changeValue={changeValueJournal("remark")}
                        key={props.clickedClient.id + "remark"}
                        clickedClient={props.clickedClient}
                        enableComment={true}
                        updatedAt={journal.updatedAt}
                        comments={getFieldComments('clientJournalRemark')}
                    />
                    <UploadFile
                        multi={true}
                        maxFiles={10}
                        therapist={therapist}
                        client={props.clickedClient}
                        journal={journal}
                        uploadInDrive={props.uploadInDrive}
                    />
                    {/* <SimpleInput
                        canEditData={props.canEditData}
                        id={journal.id + "remark"}
                        multiline={true}
                        name="clientJournalRemark"
                        text="Egne bemærkninger"
                        prop={journal.remark}
                        changeValue={changeValueJournal("remark")}
                        key={props.clickedClient.id + "remark"}
                    /> */}
                    {customFields.map((row, index) => {
                        return (
                            <>
                                {/* <SimpleInput
                                    canEditData={getCanEditDataStatus(row, 'firstInputValueDate')}
                                    id={row.customFieldId}
                                    multiline={true}
                                    text={row.name}
                                    prop={row.value}
                                    changeValue={changeValueCustomField(index)}
                                    key={row.id + "custom"}
                                /> */}
                                <SimpleInputComment
                                    canEditData={getCanEditDataStatus(row, 'firstInputValueDate')}
                                    id={row.customFieldId}
                                    multiline={true}
                                    name={row.customFieldId}
                                    text={row.name}
                                    prop={row.value}
                                    changeValue={changeValueCustomField(index)}
                                    key={row.id + "custom"}
                                    therapist={therapist}
                                    updatedAt={row.updatedAt}
                                />

                                {!row.locked && therapist.plan === "pro" && props.canEditData ? (
                                    <NewCustomFieldJournal
                                        new={false}
                                        data={row}
                                        update={setCustomFields}
                                        journalId={props.journal.id}
                                        row={row}
                                    />
                                ) : (
                                    <></>
                                )}
                            </>
                        );
                    })}
                </form>
            </AccordionDetails>
            <AccordionActions>
                <ReactToPrint trigger={() => <Button size="small">Print</Button>} content={() => printRef.current} />
                <Button size="small" onClick={props.expand}>
                    Luk
                </Button>
                {props.canEditData !== false ? (
                    <NewCustomFieldJournal
                        new={true}
                        update={setCustomFields}
                        pro={therapist.plan === "pro"}
                        journalId={props.journal.id}
                    />
                ) : (
                    <></>
                )}
                {therapist.plan !== "pro" && <PremiumBadge />}
            </AccordionActions>
        </Accordion>
    );
};
